import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  Input,
  OnInit,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Router, RouterModule } from '@angular/router';

import { FormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { DarkModeService } from '../dark-mode.service';
import { ButtonModule } from 'primeng/button';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [RouterModule, FormsModule, ButtonModule, HttpClientModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.Emulated,
})
export class FooterComponent implements OnInit {
  showConsent: boolean = false;
  isDarkMode: boolean = false;
  currentYear: number | undefined;
  constructor(
    private darkModeService: DarkModeService,
    private http: HttpClient,
  ) {}

  ngOnInit() {
    this.darkModeService.isDarkMode$.subscribe((isDarkMode) => {
      this.isDarkMode = isDarkMode;
    });

    this.currentYear = new Date().getFullYear();
    this.loadShowConsentFlag();
  }

  private async loadShowConsentFlag(): Promise<void> {
    try {
      const res = await this.http
        .get<Record<string, unknown>>(
          environment.apiUrl + '/api/Common/GetCommonAppConfigVariables',
        )
        .toPromise();

      if (res) {
        const key = Object.keys(res).find(
          (k) => k.toLowerCase() === 'changepref',
        );
        this.showConsent = key
          ? String(res[key]).toLowerCase() === 'true'
          : false;
      }
    } catch (error) {
      console.warn('Error fetching CHANGEPREF from API:', error);
      this.showConsent = false;
    }
  }

  openExternalLink(url: string): void {
    window.open(url, '_blank');
  }
}
